const MCP_PAGE = '/';

export default {
  MCP_PAGE,
  PATHS: [MCP_PAGE]
};
